import { PhoneForwarded, X } from "lucide-react"

import { Button } from "@/components/ui/button"

// Shown on the receptionist dashboard to nudge accounts that want callers to
// keep dialing their existing business number. Styled to match the Lead
// Responder's A2P banner (blue variant). Non-blocking and dismissible — the
// same flow stays reachable from the "…" menu afterward. Dismissal is persisted
// client-side (see dashboard) so it doesn't nag on every visit.
export function CallForwardingBanner({
  onSetUp,
  onDismiss,
}: {
  onSetUp: () => void
  onDismiss: () => void
}) {
  // The actions sit beside the copy from `sm` up and drop below it on a phone,
  // where a shrink-0 button next to the shrink-0 icon would squeeze the copy
  // down to one word per line.
  return (
    <div className="flex flex-col gap-3 rounded-xl border border-blue-300 bg-blue-50 p-4 sm:flex-row sm:items-start dark:border-blue-400/30 dark:bg-blue-400/10">
      <div className="flex flex-1 items-start gap-3">
        <PhoneForwarded className="mt-0.5 size-5 shrink-0 text-blue-500" />
        <div className="flex-1">
          <p className="text-sm font-medium">
            Use your existing business number
          </p>
          <p className="text-muted-foreground mt-0.5 text-sm">
            Forward calls from your current business number to your
            receptionist.
          </p>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2 pl-8 sm:pl-0">
        <Button variant="outline" size="sm" onClick={onSetUp}>
          Set up forwarding
        </Button>
        <Button
          variant="ghost"
          size="icon-sm"
          className="text-muted-foreground"
          aria-label="Dismiss"
          onClick={onDismiss}
        >
          <X className="size-4" />
        </Button>
      </div>
    </div>
  )
}
